import { graphql, useStaticQuery } from 'gatsby';

export function useBreadcrumbsMap() {
  const { breadcrumbsMap } = useStaticQuery(graphql`
    query {
      breadcrumbsMap {
        data
      }
    }
  `);

  const { map, validPages } = JSON.parse(breadcrumbsMap.data);
  return { map, validPages };
}
